import { useState } from "react";
import { Building2, Handshake, Plus, User } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { CompanyCreateDialog } from "../graph/CompanyEditor";
import { ContactCreateDialog } from "../graph/ContactCreateDialog";
import { DealCreateDialog } from "../graph/DealCreateDialog";
import { usePermission } from "../providers/usePermission";

type Creating = "contact" | "company" | "deal" | null;

/** The top bar's + New (W12 U1): the create dialogs, for roles that may create. */
export function NewMenu() {
  const canCreate = usePermission("create_records");
  const [creating, setCreating] = useState<Creating>(null);
  if (!canCreate) return null;
  const dialog = (kind: Exclude<Creating, null>) => ({
    open: creating === kind,
    onOpenChange: (open: boolean) => setCreating(open ? kind : null),
  });
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="sm" className="gap-1">
            <Plus className="size-4" />
            New
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-44">
          <DropdownMenuItem onSelect={() => setCreating("contact")}>
            <User /> Contact
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setCreating("company")}>
            <Building2 /> Company
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setCreating("deal")}>
            <Handshake /> Deal
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ContactCreateDialog {...dialog("contact")} />
      <CompanyCreateDialog {...dialog("company")} />
      <DealCreateDialog {...dialog("deal")} />
    </>
  );
}
